'use client';

import React, { useEffect } from 'react';

import gfkClient from '@/components/third-party/gfk';
import configuration from '@/configuration';

const push = (event) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
};

export const Analytics = ({ gtmId }) => {
  useEffect(() => {
    push({ event: 'gtm.js', 'gtm.start': new Date() });
    const script = document.createElement('script');
    script.src = `//www.googletagmanager.com/gtm.js?id=${gtmId}`;
    script.async = true;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, [gtmId]);
  return (
    <noscript>
      <iframe
        src={`//www.googletagmanager.com/ns.html?id=${gtmId}`}
        title="GA Iframe"
        height="0"
        width="0"
        style={{
          display: 'none',
          visibility: 'hidden',
        }}
      />
    </noscript>
  );
};

export const PageView: React.FC<{ type: string; [p: string]: string }> = ({ ...props }) => {
  useEffect(() => {
    const { type, ...eventParams } = props;
    push({
      event: 'page_view',
      page_type: type,
      ...eventParams,
    });

    const agent = gfkClient.getAgent();
    const customParams = { c1: new URL(configuration.host || window.location.toString()).host, c2: type };
    agent.impression('default', customParams);
  }, [props]);

  return null;
};
